import { render, staticRenderFns } from "./ImportExportSettingsPlugin.vue?vue&type=template&id=46bf5292&scoped=true"
import script from "./ImportExportSettingsPlugin.vue?vue&type=script&lang=js"
export * from "./ImportExportSettingsPlugin.vue?vue&type=script&lang=js"
import style0 from "./ImportExportSettingsPlugin.vue?vue&type=style&index=0&id=46bf5292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bf5292",
  null
  
)

export default component.exports